var _linearGradient, _linearGradient2, _radialGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpubIconWikimedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ccc",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ccc",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ad51a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d4f292",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1b6e03",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#379f18",
      stopOpacity: 1
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 1039.015,
    x2: 22.495,
    y1: 1044.805,
    x1: 2.21,
    gradientUnits: "userSpaceOnUse",
    id: "e",
    xlinkHref: "#b"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1.06612 0 0 1.0219 -.159 -23.001)",
    gradientUnits: "userSpaceOnUse",
    y2: 1051.026,
    x2: 2.762,
    y1: 1036.951,
    x1: 11.492,
    id: "d",
    xlinkHref: "#c"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    r: 8,
    fy: 1044.496,
    fx: 2.597,
    cy: 1044.496,
    cx: 2.597,
    gradientTransform: "matrix(1.28328 -.4625 .33906 .94077 -356.292 63.744)",
    gradientUnits: "userSpaceOnUse",
    id: "f",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m10.867 1036.459-8.881-.011s-.65.01-.812.173c-.328.329-.178.553-.178 2.115 0 3.2-.01 10.59.075 12.612a.822.822 0 0 0 .327.534c.23.152.599.157.775.159 4.465.038 12.372 0 12.372 0 .292-.239.563-.486.443-.89l-.095-11.081zm-.69 1.006v2.37s-.045.52.157.723c.175.176.536.17.813.181 1.022.042 2.751.048 2.751.048l.088 10.137-.058.12-11.881-.03.117-13.494zm1 .619 1.874 1.68-1.873-.047z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#b3b3b3",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    transform: "translate(0 -1036.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.405 1038.022 7.408-.091-.077 3.018 3.448.176.084 9.098-10.768.18z",
    style: {
      fill: "url(#d)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1.04377246px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(0 -1036.362)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#e)",
      fillOpacity: 1,
      stroke: "none"
    },
    d: "m8 1049.076-4.714-4.714L8 1039.649l1.571 1.57-3.142 3.143 1.57 1.571 4.714-4.713-4.106-4.106a.859.859 0 0 0-1.214 0l-6.641 6.641a.86.86 0 0 0 0 1.215l6.64 6.64a.859.859 0 0 0 1.215 0l6.642-6.64a.86.86 0 0 0 0-1.215l-.964-.964L8 1049.076z",
    transform: "matrix(.82844 0 0 .82844 .086 -855.903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 1049.076-4.714-4.714L8 1039.649l1.571 1.57-3.142 3.143 1.57 1.571 4.714-4.713-4.106-4.106a.859.859 0 0 0-1.214 0l-6.641 6.641a.86.86 0 0 0 0 1.215l6.64 6.64a.859.859 0 0 0 1.215 0l6.642-6.64a.86.86 0 0 0 0-1.215l-.964-.964L8 1049.076z",
    style: {
      fill: "none",
      stroke: "url(#f)",
      strokeWidth: 1.20709002,
      strokeOpacity: 1
    },
    transform: "matrix(.82844 0 0 .82844 .086 -855.903)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpubIconWikimedia);
export default __webpack_public_path__ + "static/media/epub_icon_wikimedia.ca08623298b402b52047280613419654.svg";
export { ForwardRef as ReactComponent };